import React, { Component } from "react";
import {
	RaisedButton,
	Subheader,
	GridList,
	GridTile,
	IconButton
} from "material-ui";
import FileUpload from "material-ui/svg-icons/file/file-upload";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import InfoIcon from "material-ui/svg-icons/action/info";
import { Field } from "redux-form";
import FileInput from "./FileInput";

const styles = {
	gridList: {
		display: "flex",
		flexWrap: "nowrap",
		overflowX: "auto",
		width: "auto"
	},
	input: {
		cursor: "pointer",
		position: "absolute",
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		width: "100%",
		opacity: 0
	}
};

class ImageSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			imagePreviewUrl: this.props.imagePreviewUrl
				? this.props.imagePreviewUrl
				: null,
			sizeErrorText: null,
			fileName: null
		};
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.imagePreviewUrl !== this.props.imagePreviewUrl) {
			this.setState({
				imagePreviewUrl: nextProps.imagePreviewUrl
			});
		}
	}

	handleImageChange(e) {
		e.preventDefault();
		let reader = new FileReader();
		reader.onloadend = () =>
			this.setState({ imagePreviewUrl: reader.result, sizeErrorText: null });

		reader.readAsDataURL(e.target.files[0]);

		if (e.type !== "blur")
			this.refs.field.getRenderedComponent().refs.FileInput.blur();
	}

	adaptFileEventToValue = delegate => e => {
		if (e.target.files[0]) {
			if (e.target.files[0].size < this.props.fileSize) {
				this.handleImageChange(e);
				//añadido para sindicato controlador de estado de la pantalla a la que pertenece
				// eslint-disable-next-line
				this.props.onChangeState ? this.props.onChangeState() : null;
				delegate(e.target.files[0]);
				this.setState({ fileName: e.target.files[0].name });
			} else
				this.setState({
					sizeErrorText: `El tamaño de la imagen no debe superar ${this.props
						.fileSize / 1000}kb`,
					fileName: null
				});
		}
	};

	deleteFile = () => {
		const fieldName = this.props.fieldName;
		const dispatch = this.refs.field.context._reduxForm.dispatch;
		const change = this.refs.field.context._reduxForm.change;
		dispatch(change(fieldName, ""));
		this.refs.field.getRenderedComponent().refs.FileInput.value = "";
		this.setState({ imagePreviewUrl: null });
		// eslint-disable-next-line
		this.props.onChangeDeleteFlag ? this.props.onChangeDeleteFlag() : null;
	};

	renderPreviews() {
		let previewUrl = this.state.imagePreviewUrl;
		if (previewUrl)
			return (
				<div style={this.props.styleRenderPreviews}>
					<Subheader>Vista previa</Subheader>
					<GridList cols={2} style={styles.gridList} cellHeight="auto">
						<GridTile
							title=" "
							style={{ width: 300, height: 180 }}
							actionIcon={
								this.props.disabledUploadPhoto ? null : (
									<IconButton onClick={this.deleteFile}>
										<DeleteIcon color="white" />
									</IconButton>
								)
							}
						>
							<img
								style={{ height: "100%", width: "100%", objectFit: "contain" }}
								src={previewUrl}
								alt=""
							/>
						</GridTile>
					</GridList>
				</div>
			);
	}

	render() {
		const props = this.props;
		return (
			<div className={props.classNameIS}>
				<RaisedButton
					label={props.label}
					labelPosition="before"
					containerElement="label"
					style={props.styleButton}
					icon={<FileUpload />}
					disabled={
						this.props.disabledUploadPhoto
							? this.props.disabledUploadPhoto
							: false
					}
				>
					<Field
						ref="field"
						name={props.fieldName}
						component={FileInput}
						style={styles.input}
						adaptEvent={this.adaptFileEventToValue}
						accept="image/x-png,image/jpeg"
						withRef
						disabled={
							this.props.disabledUploadPhoto
								? this.props.disabledUploadPhoto
								: false
						}
					/>
				</RaisedButton>
				{this.state.sizeErrorText ? (
					<div className="display-flex align-center">
						<InfoIcon color="#00529b" style={{ width: 16 }} />
						<p
							className="margin0 light"
							style={{ fontSize: 11, marginLeft: 5 }}
						>
							{this.state.sizeErrorText}
						</p>
					</div>
				) : null}
				{this.props.noPreview ? (
					<p
						className="margin0 light"
						style={{
							fontSize: 11,
							marginLeft: 5,
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis"
						}}
					>
						{this.state.fileName}
					</p>
				) : (
					this.renderPreviews()
				)}
			</div>
		);
	}
}

export default ImageSelector;



// WEBPACK FOOTER //
// ./src/components/ImageSelector/ImageSelector.js